import { FlexColumn } from 'common/FlexColumn';
import { D2TransformEditor } from 'components/editor/D2TransformEditor';
import { IsoShapeEditor } from 'components/editor/IsoShapeEditor';
import { SelectEditor } from 'components/editor/SelectEditor';
import { ValueEditor } from 'components/editor/ValueEditor';
import { Vec2Editor } from 'components/editor/Vec2Editor';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { SeatPrimitiveDO } from 'stores/Primitive';

type SeatPrimitivePanelProps = {
  primitive: SeatPrimitiveDO;
};

export const SeatPrimitivePanel = observer((props: SeatPrimitivePanelProps) => {
  const { primitive } = props;

  return (
    <FlexColumn>
      <D2TransformEditor value={primitive.transform} />
      <IsoShapeEditor value={primitive.shape} />
      <SelectEditor value={primitive.facing} />
    </FlexColumn>
  );
});
